let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b6ipk")).then(() => parcelRequire('ent0H'));